import { useEffect, useState } from 'react';
import MapContext from './mapContext';

type mapProviderProps = {
  children: React.ReactNode;
};

const MapProvider = (props: mapProviderProps) => {
  const { children } = props;
  const [mapInstance, setMapInstance] = useState(null);
  const [mapLoaderInstance, setMapLoaderInstance] = useState(null);
  const [googleMap, setGoogleMap] = useState(null);

  const value = {
    state: {
      mapInstance,
      mapLoaderInstance,
      googleMap
    },
    actions: {
      setMapInstance,
      setMapLoaderInstance,
      setGoogleMap
    }
  };

  return <MapContext.Provider value={value}>{children}</MapContext.Provider>;
};

export default MapProvider;
